// Identifies the domain resources touched by organization events, including
// resources carried as relationships instead of the event's primary subject.

import { type OrganizationEvent } from '@apps/web/hooks/use_organization_events';

export function organizationEventReferencesResource(
    event: OrganizationEvent,
    resourceType: OrganizationEvent['resource']['type'],
): boolean {
    return (
        event.resource.type === resourceType ||
        event.relationships.some(
            (relationship) => relationship.type === resourceType,
        )
    );
}
